import { FC } from 'react';
import { InvoiceByIdV2 } from '../../invoices.model';
import DateUtils from 'utils/dateUtils';

interface InvoiceAdditionalInfoSectionProps {
  invoice: InvoiceByIdV2;
}

const InvoiceAdditionalInfoSection: FC<InvoiceAdditionalInfoSectionProps> = ({ invoice }) => {
  const additionalInfo = [
    {
      label: 'Invoice Number',
      value: invoice.invoiceNumber
    },
    {
      label: 'Reference Number',
      value: invoice.referenceId || '-'
    },
    {
      label: 'Created On',
      value: DateUtils.parseISODateString(invoice.invoiceDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    {
      label: 'Created By',
      value: invoice?.merchantInfo?.name || '-'
    }
  ];

  return (
    <div className="rounded-md bg-white shadow-section">
      <div className="px-5 py-3 text-17px font-bold text-headingGray">Additional Info</div>
      <div className="space-y-4 px-5 pt-[6px] pb-2">
        {additionalInfo.map((info, index) => (
          <div key={index} className="flex justify-between text-sbase font-medium text-primaryText">
            <div>{info.label}</div>
            <div>{info.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceAdditionalInfoSection;
